// extracted by mini-css-extract-plugin
module.exports = {"loader":"PageOverlayLoader_loader__3gzg2","loaderOuter":"PageOverlayLoader_loaderOuter__3bLzb"};